import { Respuesta } from './../entities/respuesta.entity';
import { Factura } from './../entities/factura.entity';
import { Contrato } from './../entities/contrato.entity';
import { Component, OnInit } from '@angular/core';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { AlertService } from '../services/alert.service';
import { Router } from '@angular/router';
import { FacturaSeleccion } from '../entities/facturaSeleccion.entity';
import * as FileSaver from 'file-saver';
import { UsuarioUpdate } from '../entities/usuarioUpdate.entity';
import { UsuarioOnline } from '../entities/UsuarioOnline.entity';
import { FacturasFiltro } from '../entities/facturasFiltro';

@Component({
  selector: 'app-consumofactura',
  templateUrl: './consumofactura.component.html'
})
export class ConsumofacturaComponent implements OnInit {
  public isAuthenticated: boolean;
  public total: number;
  public consumo: number;
  public periodo: string;
  public periodocorto: string;
  public fechalectura: string;
  public explo: string;
  public factText = 'factura';

  public contratoSelected: Contrato;
  public contrato_num: number;
  public contratos: Contrato[];
  public facturas: Array<Factura>;
  public efactura: boolean;

  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public Facturaseleccionada: FacturaSeleccion = new FacturaSeleccion();
  public posicion: number;
  public existenFacturas: boolean;
  public rowsOnPage = 6;
  public SortBy = 'periodo';
  public SortOrder = 'asc';
  public tabla: any;
  public direccionSuministro: string;
  public facturasTabla: Factura[];
  public paginaActual: number;
  public registroPorPaginas: number;
  public fecfinpagoperiodo: string;
  public fecfinpagovoluntario: Date;
  public esGuadalAgua: boolean = false;
  private dateFac: Date;
  private hoy: Date;
  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.isAuthenticated = this.sessionService.isAuthenticated;
    if (this.sessionService.isAuthenticated) {
      this.explo = this.sessionService.datosExplotacion.Codigo.toUpperCase();
      if (this.explo === 'MELILLA') {
        this.factText = 'pre-factura';
      }
      if(this.explo === 'GUADALAJARA') {
        this.esGuadalAgua = true;
      }
      this.contratos = this.sessionService.contratos;
      this.efactura = this.sessionService.efactura;
      if (this.sessionService.contratoSelected === undefined) {
        this.sessionService.contratoSelected = this.contratos[0];
        this.sessionService.PosicionContratoSelected = 0;
      }
      this.cargarVariables(this.sessionService.contratoSelected);
      if (this.sessionService.contratoSelected.Facturas.length <= 6) {
        this.paginaActual = 1;
        this.registroPorPaginas = 6;
        this.obtenerFacturas(this.paginaActual, this.registroPorPaginas);
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  downloadFile() {
    const link = document.createElement('a');
    link.download = 'APLICACION DEL CANON MEDIOAMBIENTAL DIRECTIVA MARCO DEL AGUA';
    link.href = 'assets/documents/APLICACION DEL CANON MEDIOAMBIENTAL DIRECTIVA MARCO DEL AGUA.pdf';
    link.click();
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.cargarVariables(contratoSelect);
    if (this.sessionService.contratoSelected.Facturas.length <= 6) {
      this.paginaActual = 1;
      this.registroPorPaginas = 6;
      this.obtenerFacturas(this.paginaActual, this.registroPorPaginas);
    }
  }

  public obtenerFacturas(currentPageNumber: number, pageSize: number) {
    const datosObtenerFactura = new FacturasFiltro();
    datosObtenerFactura.ContratoCodigo = this.sessionService.contratoSelected.Codigo;
    datosObtenerFactura.CurrentPageNumber = currentPageNumber;
    datosObtenerFactura.Login = this.sessionService.login;
    datosObtenerFactura.PageSize = pageSize;

    this.userService.ObtenerFacturas(this.sessionService.explotacion, datosObtenerFactura).subscribe(
      response => this.ObtenerFacturasOnSuccess(response),
      response => this.ObtenerFacturasOnError(response));
  }

  public ObtenerFacturasOnSuccess(response: FacturasFiltro) {
    this.sessionService.contratoSelected.Facturas = response.Facturas;
    this.sessionService.contratos[this.sessionService.PosicionContratoSelected].Facturas = response.Facturas;
    this.contratoSelected.Facturas = response.Facturas;

    // Codigo para si queremos recuperar las facturas por paginas no todas de una vez como se hace con el codigo de arriba
    /*this.facturasTabla = [];
    let factura = new Factura();
    let periodo = new Periodo();
    factura.Periodo = periodo;
    factura.Periodo.Descripcion = null;
    const primeraposicion: number = ((response.CurrentPageNumber - 1) * response.PageSize);
    const ultimaposicion: number = (response.CurrentPageNumber * (response.PageSize - 1));
    let j = 0;

    while (this.facturasTabla.length < response.TotalRows ) {
      if (j === primeraposicion) {
        for (const item of response.Facturas) {
          this.facturasTabla.push(item);
          j = j + 1;
        }
        } else {
            this.facturasTabla.push(factura);
            j = j + 1;
       }
      }
      console.log(this.facturasTabla); */
  }

  public ObtenerFacturasOnError(response: Response) {

  }

  public cargarVariables(contrato: Contrato): void {
    this.contratoSelected = this.sessionService.contratoSelected;

    if (contrato.Facturas.length > 0) {
      this.existenFacturas = true;
      this.typeException = -1;
      this.total = contrato.Facturas[0].TotalFacturado;
      this.consumo = contrato.Facturas[0].ConsumoFactura;
      this.periodo = contrato.Facturas[0].Periodo.Descripcion;
      this.fecfinpagoperiodo = contrato.Facturas[0].Periodo.FechaFinPagoVoluntario;
      this.periodocorto = contrato.Facturas[0].PeriodoCodigo;
      this.fechalectura = contrato.Facturas[0].FechaLecturaLector.toString();
      this.Facturaseleccionada.version = contrato.Facturas[0].Version.toString();
      this.Facturaseleccionada.contratoVersion = contrato.Facturas[0].ContratoVersion.toString();
      this.facturas = contrato.Facturas;

      let facturasPendientes = 0;
      for (const fact of contrato.Facturas) {
        this.dateFac = new Date(fact.Fecha);
        this.dateFac.setDate(this.dateFac.getDate() + 30);
        // console.log('============ini=============');
        // console.log(this.dateFac);
        // console.log(this.hoy);
        // console.log('==========fin===============');
        if (fact.TotalCobrado < ((fact.TotalFacturado - 5)) && (this.dateFac > this.hoy)) {
          // if (fact.Fecha<fact.Fecha)         
          facturasPendientes = facturasPendientes + 1;         
        }
      }

      if (facturasPendientes > 0) {
        if (facturasPendientes === 1) {
          this.messageCabecera = 'Factura pendiente de cobro';
        } else {
          this.messageCabecera = 'Varias facturas pendiente de cobro';
        }
        this.typeException = 6;
      } else {
        this.messageCabecera = '';
        this.messageComplet = '';
        this.typeException = 10;
      }
    } else {
      this.existenFacturas = false;
      this.messageCabecera = 'Contrato sin facturas';
      this.messageComplet = 'El contrato seleccionado no tiene ninguna factura para mostrar';
      this.typeException = 0;
    }

    this.direccionSuministro = contrato.InmuebleBO.Direccion;
    this.Facturaseleccionada.contratoCodigo = contrato.Codigo.toString();
    this.Facturaseleccionada.periodoCodigo = this.periodocorto;
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
  }

  public DescargarFactura() {
    this.Facturaseleccionada.duplicado = (this.sessionService.efactura);
    this.Facturaseleccionada.firmarFactura = false;
    this.Facturaseleccionada.waterMarkImageFilePath = '';
    this.userService.descargaFactura(this.Facturaseleccionada)
      .subscribe(
        response => this.DescargaFacturaOnSuccess(response),
        response => this.DescargaFacturaOnError(response));
  }

  public SeleccionarUltimaFactura() {
    this.Facturaseleccionada.contratoCodigo = this.sessionService.contratoSelected.Codigo.toString();
    this.Facturaseleccionada.version = this.sessionService.contratoSelected.Facturas[0].Version.toString();
    this.Facturaseleccionada.periodoCodigo = this.sessionService.contratoSelected.Facturas[0].PeriodoCodigo;
    this.Facturaseleccionada.contratoVersion = this.sessionService.contratoSelected.Version.toString();
  }

  public SeleccionarFacturaTabla(contrato: string, version: string, periodo: string, versionContrato: string) {
    this.Facturaseleccionada.contratoCodigo = contrato;
    this.Facturaseleccionada.version = version;
    this.Facturaseleccionada.periodoCodigo = periodo;
    this.Facturaseleccionada.contratoVersion = versionContrato;
  }

  public DescargarFacturaTabla(contrato: string, version: string, periodo: string, versionContrato: string) {
    this.SeleccionarFacturaTabla(contrato, version, periodo, versionContrato);
    this.DescargarFactura();
  }

  public DescargaFacturaOnSuccess(response) {
    const fichero: Blob = response;
    const filename = 'factura_' + this.Facturaseleccionada.periodoCodigo + '.pdf';
    FileSaver.saveAs(fichero, filename);
  }

  public DescargaFacturaOnError(response) {
    this.messageCabecera = 'Error al descargar la factura';
    this.messageComplet = 'Su factura no ha podido ser descargada';
    this.typeException = 0;
  }

  public subscribirFacturaElectronica() {
    const user: UsuarioUpdate = new UsuarioUpdate();
    let usuarioOnline: UsuarioOnline = new UsuarioOnline();
    usuarioOnline = this.sessionService.usuario;
    usuarioOnline.EFactura = true;
    user.UsuarioOnline = usuarioOnline;

    this.userService.updateuser(this.sessionService.explotacion, user)
      .subscribe(
        response => this.updateuserOnSuccess(response),
        response => this.updateuserOnError(response));
  }

  public updateuserOnSuccess(response) {
    this.efactura = true;
    this.sessionService.efactura = true;
  }

  public updateuserOnError(response) {
  }

  public DescargarUltimaFactura() {
    this.SeleccionarFacturaTabla(this.contratoSelected.Codigo.toString(),
      this.contratoSelected.Facturas[0].Version.toString(), this.periodocorto,
      this.contratoSelected.Version.toString());
    this.DescargarFactura();
  }

  public pageChangedAction(paginaActiva: number, filasPorPagina: number) {
    // codigo que sera necesario si queremos llamar al servicio web para ir recuperando pagina a pagina
    /* console.log('Paginas activa: ' + paginaActiva + ' - ' + 'Filas por pagina:' + filasPorPagina);
     if ((this.paginaActual !== paginaActiva) || (this.registroPorPaginas !== filasPorPagina)) {
       this.paginaActual = paginaActiva;
       this.registroPorPaginas = filasPorPagina;
       this.obtenerFacturas(paginaActiva, filasPorPagina);
     }*/
  }

  public muestroPendiete(fechafinpago: string) {
    this.hoy = new Date();
    this.fecfinpagovoluntario = new Date(fechafinpago );
    this.fecfinpagovoluntario.setDate(this.fecfinpagovoluntario.getDate() + 20);
    if (this.fecfinpagovoluntario > this.hoy) {
      console.log(fechafinpago + ' se muestra pendiente' + this.hoy);
      return true;
    } else {
      console.log(fechafinpago + ' se muestra nada' + this.hoy);
     return false;
   }
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/consumofactura.component.ts